import create from '@verndale/core';

import initGlobalComponents from './components/global';
import { reactModule } from './utils/react';

const modules = [
  {
    name: 'backToTopButton',
    loader: () => import('./modules/back-to-top-button')
  },
  {
    name: 'featuredItemsCarousel',
    loader: () => import('./modules/featured-items-carousel')
  },
  {
    name: 'resourcesContentCards',
    loader: () => import('./modules/resourcesContentCards')
  },
  {
    name: 'heroSlider',
    loader: () => import('./modules/heroSlider')
  },
  {
    name: 'videoModal',
    loader: () => import('./modules/videoModal')
  },
  {
    name: 'pdpAnchorBar',
    loader: () => import('./modules/pdp-anchor-bar')
  },
  {
    name: 'genericAccordion',
    loader: () => import('./modules/generic-accordion')
  },
  {
    name: 'modalImageGallery',
    loader: () => import('./modules/modal-image-gallery')
  },
  {
    name: 'modalPrivacyPolicy',
    loader: () => import('./modules/modal-privacy-policy')
  },
  {
    name: 'productReferences',
    loader: () => import('./modules/product-references')
  },
  {
    name: 'footer',
    loader: () => import('./modules/footer')
  },
  {
    name: 'modalCertificateOrigin',
    loader: () => import('./modules/modal-certificate-origin')
  },
  {
    name: 'modalCertificateAnalysis',
    loader: () => import('./modules/modal-certificate-analysis')
  },
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'primaryNav',
    loader: () => import('./modules/primary-nav')
  },
  {
    name: 'locationSelector',
    loader: () => import('./modules/location-selector')
  },
  {
    name: 'applyForAtccAccount',
    loader: () => import('./modules/apply-for-atcc-account')
  },
  {
    name: 'applyForAtccAccountEndUser',
    loader: () => import('./modules/apply-for-atcc-account-end-user')
  },
  {
    name: 'applyForAtccAccountEndUserForm',
    loader: () => import('./modules/apply-for-atcc-account-end-user-form')
  },
  {
    name: 'modalCart',
    loader: () => import('./modules/modal-cart')
  },
  {
    name: 'productListing',
    loader: () => import('./modules/product-listing')
  },
  {
    name: 'validationForm',
    loader: () => import('./modules/validationForm')
  },
  {
    name: 'documentListing',
    loader: () => import('./modules/document-listing')
  },
  {
    name: 'buyNowWidget',
    loader: () => import('./modules/buy-now-widget')
  },
  {
    name: 'alternativeBuyNowWidget',
    loader: () => import('./modules/alternative-buy-now-widget')
  },
  {
    name: 'modalLgcShoppingList',
    loader: () => import('./modules/modal-lgc-shopping-list')
  },
  {
    name: 'siteExitModal',
    loader: () => import('./modules/modal-site-exit')
  },
  {
    name: 'modalEloqua',
    loader: () => import('./modules/modal-eloqua')
  },
  {
    name: 'modalEloquaIframe',
    loader: () => import('./modules/modal-eloqua-iframe')
  },
  {
    name: 'modalConfirmation',
    loader: () => import('./modules/modal-confirmation')
  },
  {
    name: 'videoComponentWith2Ctas',
    loader: () => import('./modules/video-component-with-2-ctas')
  },
  {
    name: 'modalLgcShoppingListReact',
    loader: () => import('./react-modules/lgc-shopping-list'),
    render: reactModule
  },
  {
    name: 'gpsModule',
    loader: () => import('./modules/gpsModule')
  },
  {
    name: 'register-wizard',
    loader: () => import('./modules/register-wizard')
  },
  {
    name: 'forgotPassword',
    loader: () => import('./modules/forgot-password')
  },
  {
    name: 'modalLoginAccountSelection',
    loader: () => import('./modules/modal-login-account-selection')
  },
  {
    name: 'modalLoginPrompt',
    loader: () => import('./modules/modal-login-prompt')
  },
  {
    name: 'eloquaForm',
    loader: () => import('./components/eloqua-form')
  },
  {
    name: 'eloquaModule',
    loader: () => import('./modules/eloqua-module')
  },
  {
    name: 'modalExistingPendingAccountApplication',
    loader: () => import('./modules/modal-existing-pending-account-application')
  },
  {
    name: 'alert',
    loader: () => import('./modules/alert')
  },
  {
    name: 'findDistributorReact',
    loader: () => import('./react-modules/find-distributor'),
    render: reactModule
  },
  {
    name: 'eventListing',
    loader: () => import('./react-modules/event-listing'),
    render: reactModule
  },
  {
    name: 'eventsListingNewsletter',
    loader: () => import('./modules/events-listing-newsletter')
  },
  {
    name: 'homeTagline',
    loader: () => import('./modules/home-tagline')
  },
  {
    name: 'sectionNavigation',
    loader: () => import('./modules/section-navigation')
  },
  {
    name: 'certificateOfAnalisis',
    loader: () => import('./modules/certificate-of-analisis')
  },
  {
    name: 'modalLinkAccount',
    loader: () => import('./modules/modal-link-account')
  },
  {
    name: 'myDashboardAccountSummary',
    loader: () => import('./modules/my-dashboard-account-summary')
  },
  {
    name: 'productFaqs',
    loader: () => import('./modules/product-faqs')
  },
  {
    name: 'myAddressListing',
    loader: () => import('./modules/my-address-listing')
  },
  {
    name: 'accountsListing',
    loader: () => import('./modules/accounts-listing')
  },
  {
    name: 'modalAddContact',
    loader: () => import('./modules/modal-add-contact')
  },
  {
    name: 'shippingInformation',
    loader: () => import('./modules/shipping-information')
  },
  {
    name: 'changeBsl',
    loader: () => import('./modules/change-bsl')
  },
  {
    name: 'faqDetail',
    loader: () => import('./modules/faq-detail')
  },
  {
    name: 'dashboardBenefit',
    loader: () => import('./modules/dashboard-benefit')
  },
  {
    name: 'cartReact',
    loader: () => import('./react-modules/cart'),
    render: reactModule
  },
  {
    name: 'modalMissingCustomerAccount',
    loader: () => import('./modules/modal-missing-customer-account')
  },
  {
    name: 'coveoPager',
    loader: () => import('./react-modules/coveo-pager'),
    render: reactModule
  },
  {
    name: 'billingInformation',
    loader: () => import('./modules/billing-information')
  },
  {
    name: 'modalSelectEndUserRecipient',
    loader: () => import('./modules/modal-select-end-user-recipient')
  },
  {
    name: 'selectEndUserRecipientReact',
    loader: () => import('./react-modules/select-end-user-or-recipient'),
    render: reactModule
  },
  {
    name: 'productCategoryListing',
    loader: () => import('./modules/product-category-listing')
  },
  {
    name: 'validateRegisterWizardForm',
    loader: () => import('./modules/validate-register-wizard-form')
  },
  {
    name: 'checkoutReview',
    loader: () => import('./modules/checkout-review')
  },
  {
    name: 'modalChangeAddress',
    loader: () => import('./modules/modal-change-address')
  },
  {
    name: 'changeAddressReact',
    loader: () => import('./react-modules/change-address'),
    render: reactModule
  },
  {
    name: 'staticPagerReact',
    loader: () => import('./react-modules/static-pager'),
    render: reactModule
  },
  {
    name: 'myProfile',
    loader: () => import('./modules/my-profile')
  },
  {
    name: 'globalSearchSave',
    loader: () => import('./modules/global-search-save')
  },
  {
    name: 'orderListingReact',
    loader: () => import('./react-modules/order-listing'),
    render: reactModule
  },
  {
    name: 'orderDetail',
    loader: () => import('./modules/order-detail')
  },
  {
    name: 'newAddress',
    loader: () => import('./modules/new-address')
  },
  {
    name: 'contactListingReact',
    loader: () => import('./react-modules/contact-listing'),
    render: reactModule
  },
  {
    name: 'supportLanding',
    loader: () => import('./modules/support-landing')
  },
  {
    name: 'resetPassword',
    loader: () => import('./modules/reset-password')
  },
  {
    name: 'orderPayment',
    loader: () => import('./modules/order-payment')
  },
  {
    name: 'contactUs',
    loader: () => import('./modules/contact-us-module')
  },
  {
    name: 'strDatabaseSearch',
    loader: () => import('./modules/str-database-search')
  },
  {
    name: 'strDatabaseSearchReact',
    loader: () => import('./react-modules/str-database-search'),
    render: reactModule
  },
  {
    name: 'modalTimeout',
    loader: () => import('./modules/modal-timeout')
  },
  {
    name: 'sessionTimeout',
    loader: () => import('./modules/session-timeout')
  },
  {
    name: 'ssoAuthForm',
    loader: () => import('./modules/sso-auth-form')
  },
  {
    name: 'modalQuickView',
    loader: () => import('./modules/modal-quick-view')
  },
  {
    name: 'modalQuickViewReact',
    loader: () => import('./react-modules/quick-view'),
    render: reactModule
  },
  {
    name: 'alternativeProductCompareModal',
    loader: () => import('./modules/alternative-product-compare-modal')
  },
  {
    name: 'ordersSearch',
    loader: () => import('./modules/orders-search')
  },
  {
    name: 'savedSearchesListingReact',
    loader: () => import('./react-modules/saved-searches-listing'),
    render: reactModule
  },
  {
    name: 'modalAddToList',
    loader: () => import('./modules/modal-add-to-list')
  },
  {
    name: 'productCompareModal',
    loader: () => import('./modules/product-compare-modal')
  },
  {
    name: 'productCompareModalPreview',
    loader: () => import('./modules/product-compare-modal-preview')
  },
  {
    name: 'modalAddToListReact',
    loader: () => import('./react-modules/add-to-list'),
    render: reactModule
  },
  {
    name: 'savedCartTop',
    loader: () => import('./modules/saved-cart-top')
  },
  {
    name: 'addressesSearch',
    loader: () => import('./modules/addresses-search')
  },
  {
    name: 'modalAddressValidation',
    loader: () => import('./modules/modal-address-validation')
  },
  {
    name: 'modalResidentialAddressValidation',
    loader: () => import('./modules/modal-residential-address-validation')
  },
  {
    name: 'blogListing',
    loader: () => import('./modules/blog-listing')
  },
  {
    name: 'eventListingModule',
    loader: () => import('./react-modules/event-listing/event-listing-module'),
    render: reactModule
  },
  {
    name: 'listIndexReact',
    loader: () => import('./react-modules/list-index'),
    render: reactModule
  },
  {
    name: 'quoteDetail',
    loader: () => import('./modules/quote-detail')
  },
  {
    name: 'savedCartsDetail',
    loader: () => import('./react-modules/cart/saved-carts-detail'),
    render: reactModule
  },
  {
    name: 'listDetail',
    loader: () => import('./react-modules/list-detail'),
    render: reactModule
  },
  {
    name: 'quickOrderPageUploadFile',
    loader: () => import('./modules/quick-order-page-upload-file')
  },
  {
    name: 'quickOrderManual',
    loader: () => import('./react-modules/quick-order-manual'),
    render: reactModule
  },
  {
    name: 'quickOrderResultsReact',
    loader: () => import('./react-modules/quick-order-result'),
    render: reactModule
  },
  {
    name: 'invoiceListing',
    loader: () => import('./react-modules/invoice-listing'),
    render: reactModule
  },
  {
    name: 'savedCartsReact',
    loader: () => import('./react-modules/saved-carts'),
    render: reactModule
  },
  {
    name: 'quotesListingReact',
    loader: () => import('./react-modules/quotes-listing'),
    render: reactModule
  },
  {
    name: 'modalConvertToQuote',
    loader: () => import('./modules/modal-convert-to-quote')
  },
  {
    name: 'modalRequestQuoteModification',
    loader: () => import('./modules/modal-request-quote-modification')
  },
  {
    name: 'pressReleaseRow',
    loader: () => import('./modules/press-release-row')
  },
  {
    name: 'productListingAsync',
    loader: () => import('./modules/product-listing-async')
  },
  {
    name: 'mtaSignaturePage',
    loader: () => import('./modules/atcc-mta-signature-page')
  },
  {
    name: 'mtaStatusCheckPage',
    loader: () => import('./modules/atcc-mta-status-check-page')
  },
  {
    name: 'modalAccountVerification',
    loader: () => import('./modules/modal-account-verification')
  },
  {
    name: 'mtaUnderRewviewPage',
    loader: () => import('./modules/atcc-mta-under-review-page')
  },
  {
    name: 'modalNotifyMe',
    loader: () => import('./modules/modal-notify-me')
  },
  {
    name: 'modalLotInformationReact',
    loader: () => import('./react-modules/specific-lot-information'),
    render: reactModule
  },
  {
    name: 'newAddressBsl3CheckList',
    loader: () => import('./modules/new-address-bsl3-checklist')
  }
];

let modulesCreated = false;

window._on('DOMContentLoaded', () => {
  if (modulesCreated) return;

  modulesCreated = true;
  initGlobalComponents();
  create(modules);
});
